import { authGuard } from '../services/guards/auth.guard';
import { permissionGuard } from '../services/guards/permission.guard';
import { PermissionValue, ResourceValue } from '../services/permissions/permissions.types';
import { TitleTranslateResolver } from '../services/translate/title-translate.resolver';
import { PortalPath, PortalRoute, PortalRouteData, RouteItem } from './app.types';
import { TranslateRegistry } from '../services/translate/translate.registry';
import { provideFieldOperationsListing } from '../pages/equipment/field-operations/listing/field-operations-listing.providers';
import { provideFieldOperationsSensorsListing } from '../pages/field-operations/sensors/listing/field-operations-sensors-listing.providers';
import { featureToggleKeys } from '../services/toggle/toggle.constants';
import { featureToggleGuard } from '../services/guards/feature-toggle.guard';
import { provideBaseStationListing } from '../pages/equipment/base-stations-listing-page/listing/base-stations-listing.providers';

export const fieldOperationsLogRoutes: PortalRoute = {
  path: PortalPath.fieldOperations,
  canMatch: [authGuard, permissionGuard],
  data: {
    routeItem: new RouteItem({
      path: PortalPath.fieldOperations,
      group: TranslateRegistry.get.MAIN_MENU.SECTION.EQUIPMENT,
      title: TranslateRegistry.get.INSTALLATION_HISTORY.TITLE.FIELD_OPERATIONS,
      hasRight: {
        resourceValue: ResourceValue.FIELD_OPERATIONS,
        targetPermissionValue: PermissionValue.VIEW
      },
      icon: 'install',
      isNonNavigable: true
    })
  } satisfies PortalRouteData,
  children: [
    {
      path: '',
      redirectTo: PortalPath.metering,
      pathMatch: 'full'
    },
    {
      path: PortalPath.metering,
      title: TitleTranslateResolver,
      canMatch: [permissionGuard],
      data: {
        hasListingLayout: true,
        routeItem: new RouteItem({
          title: TranslateRegistry.get.MAIN_MENU.TITLE.METERING,
          path: `${PortalPath.fieldOperations}/${PortalPath.metering}`,
          hasRight: {
            resourceValue: ResourceValue.FIELD_OPERATIONS_METERING,
            targetPermissionValue: PermissionValue.VIEW
          }
        }),
        titleTranslation: TranslateRegistry.get.INSTALLATION_HISTORY.TITLE.FIELD_OPERATIONS
      },
      loadComponent: () =>
        import('../shared/components/listing-page/listing-page.component').then(c => c.ListingPageComponent),
      providers: provideFieldOperationsListing()
    },
    {
      path: PortalPath.sensors,
      title: TitleTranslateResolver,
      // todo: uncomment when we have ResourceValue.FIELD_OPERATIONS_SENSORS permission
      //canMatch: [permissionGuard],
      data: {
        hasListingLayout: true,
        routeItem: new RouteItem({
          title: TranslateRegistry.get.MAIN_MENU.TITLE.SENSORS,
          path: `${PortalPath.fieldOperations}/${PortalPath.sensors}`
          // todo: uncomment when we have ResourceValue.FIELD_OPERATIONS_SENSORS permission
          /*           hasRight: {
            resourceValue: ResourceValue.FIELD_OPERATIONS_SENSORS,
            targetPermissionValue: PermissionValue.VIEW
          } */
        }),
        titleTranslation: TranslateRegistry.get.INSTALLATION_HISTORY.TITLE.FIELD_OPERATIONS
      },
      loadComponent: () =>
        import('../shared/components/listing-page/listing-page.component').then(c => c.ListingPageComponent),
      providers: provideFieldOperationsSensorsListing()
    },
    {
      path: PortalPath.basestationProvisioning,
      title: TitleTranslateResolver,
      loadComponent: () =>
        import('../pages/equipment/base-stations-listing-page/base-stations-listing-page.component').then(
          c => c.BaseStationsListingPageComponent
        ),
      data: {
        titleTranslation: TranslateRegistry.get.MAIN_MENU.TITLE.BASE_STATIONS,
        routeItem: new RouteItem({
          title: TranslateRegistry.get.MAIN_MENU.TITLE.BASE_STATIONS,
          path: `${PortalPath.fieldOperations}/${PortalPath.basestationProvisioning}`,
          icon: 'table',
          featureToggleKey: featureToggleKeys.BaseStationProvisioning,
          hasRight: {
            resourceValue: ResourceValue.BASE_STATIONS_PROVISIONING,
            targetPermissionValue: PermissionValue.VIEW
          }
        }),
        hasListingLayout: true
      } as PortalRouteData,
      providers: provideBaseStationListing(),
      canMatch: [authGuard, permissionGuard, featureToggleGuard]
    }
  ]
};
